// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_1tKjlmoBcdswgFRGdUSQGL","icon":"_20bxuVSgpqpjD94aBWLT7w","active":"_21tw-v3IO3Euw645RTpcnM"};